import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import type { Metadata } from '@/types/v2/metadata';
import { useUser } from '@/hooks/v2/use-user';

import { CommunitySettingsHeader } from './community-settings-header';
import { SideNav } from './side-nav';
import { LayoutContainer } from '@/layouts/v2/layout-container';

interface LayoutProps {
  children: React.ReactNode;
  metadata: Metadata;
}

export function Layout({ children, metadata }: LayoutProps): React.JSX.Element {
  const { community } = useUser();
  return (
    <LayoutContainer metadata={{ title: metadata.title }}>
      <CommunitySettingsHeader
        community={community!}
        error={null}
        isLoading={false}
        sx={{
          mt: 4,
        }}
      />
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ position: 'relative' }}>
        <SideNav />
        <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{children}</Box>
      </Stack>
    </LayoutContainer>
  );
}

// Also export as CommunitySettingsLayout for backwards compatibility
export { Layout as CommunitySettingsLayout };
